<div class="ibe-loading-circle">
    <div class="ibe-double-bounce-1"></div>
    <div class="ibe-double-bounce-2"></div>
</div>
